<template>
    <div class="materi-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col-lg-6">
                                <h6 class="text-uppercase ls-1 mb-1">Upload Kelulusan Siswa</h6>
                            </div>
                            <div class="col-lg-6 text-lg-right">
                                
                            </div>
                        </div>
                        <div class="text-center text-muted">
                            <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                                <div class="p-2">
                                    <b-row>
                                        <b-col lg="5" class="my-1">
                                            <b-button 
                                                variant="primary" 
                                                style="border-radius:0px !important;" 
                                                class="btn btn-danger" 
                                                @click="downloadExcel()">
                                                Download Template
                                            </b-button>
                                            <b-button 
                                                variant="primary" 
                                                style="border-radius:0px !important;" 
                                                class="btn btn-info" 
                                                @click="showImportFormModal()">
                                                Upload Data
                                            </b-button>
                                            <!-- <b-button 
                                                variant="primary" 
                                                style="border-radius:0px !important;" 
                                                class="btn btn-danger" 
                                                @click="downloadPdf(filter_form)">
                                                Download Pdf
                                            </b-button> -->
                                        </b-col>
                                        <b-col lg="4" class="my-1">
                                        </b-col>
                                        <b-col lg="3" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="filter_form.tahunAjaranId"
                                                    name="classId"
                                                    v-validate="'required'"
                                                    value-field="id"
                                                    placeholder="Tahun Ajaran"
                                                    text-field="name"
                                                    data-vv-as="Tahun Ajaran"
                                                    :options="taList"
                                                >
                                                    <b-form-select-option :value="0" disabled>Pilih Tahun Ajaran</b-form-select-option>
                                                </b-form-select>
                                                <b-input-group-append>
                                                    <b-button variant="primary" :disabled="!filter_form.tahunAjaranId && !filter_form.userId" style="border-radius:0px !important;" class="btn btn-primary" @click="getStudentGraduationList()">Filter</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="1" class="my-1" style="width:100px">
                                            <b-form-select
                                                id="per-page-select"
                                                v-model="perPage"
                                                :options="pageOptions"
                                                size="sm"
                                            ></b-form-select>
                                        </b-col>
                                        <b-col lg="5" class="my-1">
                                            
                                        </b-col>
                                        <b-col lg="3" class="my-1"></b-col>
                                        <b-col lg="3" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-input
                                                id="filter-input"
                                                v-model="filter"
                                                type="search"
                                                placeholder="Cari"
                                                ></b-form-input>

                                                <b-input-group-append>
                                                <b-button variant="primary" style="border-radius:0px !important;" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-table
                                        :items="studentGraduationList"
                                        :fields="fields"
                                        :busy="isBusy"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        :filter="filter"
                                        :filter-included-fields="filterOn"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :sort-direction="sortDirection"
                                        responsive="sm"
                                        show-empty
                                        small
                                        @filtered="onFiltered"
                                    >
                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                                <b-spinner class="align-middle"></b-spinner>
                                            </div>
                                        </template>
                                        <template #cell(no)="row">
                                            <div class="list-murid text-center ">
                                                <label>{{row.item.no}}</label>
                                            </div>
                                        </template>
                                        <template #cell(full_name)="row">
                                            <div class="list-murid text-left ">
                                                <label>{{row.item.full_name}}</label>
                                            </div>
                                        </template>
                                        <template #cell(email)="row">
                                            <div class="list-murid text-left">
                                                <label>{{row.item.email}}</label>
                                            </div>
                                        </template>
                                        <template #cell(class)="row">
                                            <div class="list-murid text-center">
                                                <label>{{row.item.class}}</label>
                                            </div>
                                        </template>
                                        <template #cell(no_surat)="row">
                                            <div class="list-murid text-center">
                                                <label>{{row.item.no_surat}}</label>
                                            </div>
                                        </template>
                                        <template #cell(total)="row">
                                            <div class="list-murid text-center">
                                                <label>{{row.item.total}}</label>
                                            </div>
                                        </template>
                                        <template #cell(is_active)="row">
                                            <div class="list-murid text-center">
                                                <label>{{row.item.is_active=='0' ? 'Ya' : 'Tidak'}}</label>
                                            </div>
                                        </template>
                                        <template #cell(actions)="row">
                                            <div class="my-2">
                                                <a href="javascript:void(0)" v-b-tooltip.hover title="Detail Nilai" class="icon-clicked p-1" @click="showFormModal(row.item.detail)"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                <a href="javascript:void(0)" v-b-tooltip.hover title="Cetak Nilai" class="icon-clicked p-1" @click="cetakNilai(row.item.user_id)"><i class="fa fa-print" aria-hidden="true"></i></a>
                                                <a href="javascript:void(0)" v-b-tooltip.hover title="Hapus Data" class="icon-clicked p-1" @click="confirmDelete(row.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                            </div>
                                        </template>
                                    </b-table>
                                    <div class="d-flex justify-content-lg-end justify-content-center py-2">
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                            align="fill"
                                            size="sm"
                                            class="my-0"
                                        ></b-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

            </div>
        </div>
        <b-modal
			ref="graduation-import-form-modal"
			class="graduation-import-form-modal"
			size="md"
            title="Import Data"
            @show="resetImportForm"
            @hidden="resetImportForm"
			hide-footer
			no-close-on-backdrop
		>
            <b-form data-vv-scope="graduation-import-form">
                <b-form-group
                    label="Data"
                    label-for="data"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-file
                        ref="file_path"
                        name="file_path"
                        data-vv-as="File data"
                        v-model="import_form.file_data"
                        :state="Boolean(import_form.file_data)"
                        type="file"
                        placeholder="Pilih file disini. . ."
                        drop-placeholder="Drop file here..."
                        v-validate="'required'"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('graduation-import-form.file_path') }">{{ errors.first('graduation-import-form.file_path') }}</span>
                </b-form-group>
            </b-form>
            <hr class="m-0">
            <div class="form-footer d-flex justify-content-end mt-3">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideImportFormModal">BATAL</b-button>
                <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveImportSoal">UPLOAD</b-button>
            </div>
		</b-modal>
        <b-modal
			ref="nilai-form-modal"
			class="nilai-form-modal"
			size="md"
            title="Detail Nilai"
            hide-footer
			no-close-on-backdrop
		>
            <nilai-kelulusan-form
                :detail="detail"
            ></nilai-kelulusan-form>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import NilaiKelulusanForm from "../../../components/Main/NilaiKelulusanForm";
    import axios from '../../../axiosHelper';

    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            SquareLoader,
            NilaiKelulusanForm
        },
        data() {
            return {
                detail: [{}],
                subjectId: this.$route.params.subjectId,
                isBusy: false,
                showLoader: false,
                import_form: {
                    file_data: null
                },
                items: [],
                filter_form: {
                    tahunAjaranId: 1,
                    userId: 0,
                },
                totalRows: 1000,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                fields: [
                    { key: 'no', label: 'No.', sortable: true, class: 'text-center' },
                    { key: 'full_name', label: 'Nama Lengkap', sortable: true, class: 'text-left' },
                    { key: 'email', label: 'Email', sortable: true, sortDirection: 'desc', class: 'text-left' },
                    { key: 'class', label: 'Kelas', sortable: true, class: 'text-center'},
                    { key: 'no_surat', label: 'Nomor Surat', sortable: true, class: 'text-center'},
                    { key: 'total', label: 'Total', sortable: true, class: 'text-center'},
                    { key: 'actions', label: 'Aksi', class: 'action-field' }
                ],
            }
        },
        computed: {
            ...mapGetters({
                studentGraduationList: 'getStudentGraduationList',
                userListGraduation: 'getUserListGraduation',
                taList: 'getTaList',
                token: 'getToken'
            })
        },
        methods: {
            downloadPdf(param) {
                let token = this.token
                let route = axios.defaults.baseURL+'/v1/student-progress/download-kelulusan-siswa/'+param.tahunAjaranId+'?token='+token
                window.open(route);
            },
            showFormModal(param) {
                this.detail = param
                this.$refs['nilai-form-modal'].show()
            },
            hideFormModal() {
                this.$refs['nilai-form-modal'].hide()
                this.resetForm()
            },
            showImportFormModal() {
                this.$refs['graduation-import-form-modal'].show();
            },
            hideImportFormModal() {
                this.$refs['graduation-import-form-modal'].hide()
                this.resetImportForm()
                this.getStudentGraduationList()
            },
            resetImportForm() {
                this.import_form.file_data = null
                this.$validator.reset()
            },
            downloadExcel() {
                let token = this.token
                let route = axios.defaults.baseURL+'/v1/student-progress/download-template-graduation?token='+token
                window.open(route);
            },
            cetakNilai(id) {
                let token = this.token
                let route = axios.defaults.baseURL+'/v1/student-progress/cetak-nilai/'+id+'?token='+token
                window.open(route);
            },
			onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async getTaList() {
                this.isBusy = true
				await this.$store.dispatch('getTaList')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getStudentGraduationList() {
                this.isBusy = true
                let userId = this.filter_form.userId;
                let tahunAjaranId = this.filter_form.tahunAjaranId;
                await this.$store.dispatch('getStudentGraduationList',{tahunAjaranId,userId})
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getUserListGraduation() {
                this.isBusy = true
                
				await this.$store.dispatch('getUserListGraduation')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async saveImportSoal() {
                let scope = 'graduation-import-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let formData = new FormData()
                        formData.append('file', this.import_form.file_data)
                        this.$store.dispatch('importGraduation', formData)
                            .then((res) => {
                                this.showLoader = false
                                this.$swal.fire('Success', res.data.message, 'success')
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                this.$swal.fire('Failed', error.data.message, 'error')
                                }
                            })
                    }
                })
            },
            async confirmDelete(refId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteKelulusan(refId)
                    }
                })
			},
            async deleteKelulusan(id) {
				await this.$store.dispatch('deleteKelulusan', { id })
					.then((res) => {
                        this.getStudentGraduationList()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
        },
        destroyed() {
            let resp = null
            this.$store.commit('setStudentGraduationList', { resp })
            this.$store.commit('setUserListGraduation', { resp })
        },
        mounted() {
            //
        },
        async created() {
            this.getStudentGraduationList()
            await this.getUserListGraduation()
            await this.getTaList()
            
            this.totalRows = this.studentGraduationList.length
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
.table-perkembangan {
    width: 100%;
    margin: 20px auto;
    table-layout: auto;
    border: 1px solid #555;
    border-width: 0 1px 0 1px;
}
.t-column-header {
    border: 1px solid #555;
    border-width: 0px 1px 0px 1px;
}
.t-column-body {
    border: 1px solid #555;
    border-width: 1px 1px 1px 1px;
}

</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
#student-progress {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#student-progress td, #student-progress th {
  border: 1px solid #ddd;
  padding: 8px;
}

#student-progress tr:nth-child(even){background-color: #f2f2f2;}

#student-progress tr:hover {background-color: #ddd;}

#student-progress th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
</style>